<template>
  <form @submit.prevent="save">
    <transition name="overlay-fade">
      <product-progress
        :progress="progress"
        class="progress-window"
        v-if="saving"
      ></product-progress>
    </transition>
    <close-button @click="$emit('close')" class="close-button"></close-button>

    <div class="dialog-header">
      <h1>Ontwerp toevoegen</h1>
    </div>
    <div class="dialog-content">
      <div class="field-wrapper">
        <div class="field-100 label-fix">
          <label>Naam</label>
          <div class="files">
            <div v-for="file in files" :key="file.id">
              {{ file.name }}
            </div>
          </div>
        </div>
      </div>

      <div class="field-wrapper">
        <div class="field-100 label-fix">
          <label>Product</label>
          <div>
            <popup-menu class="popup" anchor-position="top">
              <span slot="trigger"
                ><span class="product-type-placeholder" v-if="!productType"
                  >Kies een product</span
                >
                <span v-else class="product-type">{{ productType }}</span
                ><button class="chevron down"></button
              ></span>
              <menu-item
                v-for="productType in rootStore.printStore.productTypes"
                :key="productType.id"
                @click="setProductType(productType)"
                >{{ productType.name }}
              </menu-item>
            </popup-menu>
          </div>
        </div>
      </div>

      <div class="field-wrapper">
        <div class="field-100 label-fix">
          <label for="designer">Ontwerp</label>
          <div>
            <input
              id="designer"
              type="text"
              v-model="designer"
              name="designer"
              placeholder="Ontwerper"
            />
          </div>
        </div>
      </div>

      <div class="field-wrapper">
        <div class="field-100 label-fix">
          <label for="description">Beschrijving</label>
          <div>
            <textarea
              id="description"
              type="text"
              v-model="description"
              name="description"
              placeholder="Voeg een heldere beschrijving van het ontwerp toe"
            ></textarea>
          </div>
        </div>
      </div>

      <div class="field-wrapper">
        <div class="field-100">
          <select-box
            :selected="showBorder"
            @action="showBorder = !showBorder"
          ></select-box>
          <span class="pointer" @click="showBorder = !showBorder">
            Toon een rand om preview afbeelding
          </span>
        </div>
      </div>

      <div class="button-holder">
        <button
          id="confirm-button"
          class="pill-button"
          type="submit"
          :disabled="!files.length || !productType"
        >
          Opslaan
        </button>
      </div>
    </div>
  </form>
</template>
<script>
import { mapStores } from 'pinia'
import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'
import { addProduct } from '@/features/printstore/PrintStoreApi'
import { uuidv4 } from '@/api/uuid'
import ProductProgress from './addProduct/ProductProgress.vue'

export default {
  props: ['files', 'callback', 'categoryId', 'collectionId'],
  components: {
    ProductProgress
  },
  data() {
    return {
      saving: false,
      productType: '',
      description: '',
      designer: '',
      showBorder: false,
      productTypeId: undefined,
      productTypes: []
    }
  },
  computed: {
    ...mapStores(usePrintStoreStore),
    progress() {
      return this.printStoreStore.upload.progress
    }
  },
  methods: {
    setProductType(productType) {
      this.productTypeId = productType.id
      this.productType = productType.name
    },
    async save() {
      this.saving = true
      // Generate products in backend
      let productIdMap = new Map()

      for (const file of this.files) {
        const productId = uuidv4()

        // Strip off extension
        const fileName = file.name.substring(0, file.name.lastIndexOf('.'))

        await addProduct({
          id: productId,
          name: fileName,
          categoryId: this.categoryId,
          productTypeId: this.productTypeId,
          collectionId: this.collectionId,
          description: this.description,
          designer: this.designer,
          displaySpecification: { border: this.showBorder }
        })
        productIdMap.set(file.uniqueIdentifier, productId)
      }

      this.callback(productIdMap)
    }
  }
}
</script>
<style lang="scss" scoped>
@use '../../../sass/base/_colors.scss' as *;

.progress-window {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 10;
}

.chevron {
  color: var(--sub-color);
  padding-left: 8px;
  vertical-align: top;
}

.popup {
  display: inline-block;
  vertical-align: text-top;
}

:deep(.menu .menu-items) {
  max-height: 250px;
  overflow-y: auto;
}

label {
  width: 90px;
}

.category {
  color: $text-color;
}

textarea {
  width: 100%;
  height: 120px;
}

.field-wrapper {
  margin-bottom: 20px;
}

.product-type {
  color: var(--sub-color);
  font-weight: 500;
}

.product-type-placeholder {
  color: var(--error-color);
  font-style: italic;
}

.field-wrapper .label-fix .files {
  max-height: 165px;
  overflow: auto;

  div {
    padding-bottom: 5px;
  }
}
</style>
